const env = process.env;

const config = {
  api: {
    drug: {
      url: env.VUE_APP_API_DRUG_URL,
      timeout: env.VUE_APP_API_DRUG_TIMEOUT,
    },
    strategy: {
      url: env.VUE_APP_API_STRATEGY_URL,
      timeout: env.VUE_APP_API_STRATEGY_TIMEOUT,
    },
    health: {
      url: env.VUE_APP_API_HEALTH_URL,
      timeout: env.VUE_APP_API_HEALTH_TIMEOUT,
    },
  },
};

export default config;
